// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import toastEventBus from 'primevue/toasteventbus'

import i18n from '@/libs/i18n'

const { t } = i18n.global
const PrintSuccess = (message: string) => {
    toastEventBus.emit('add', { severity: 'success', summary: t('general.success'), detail: message, life: 3000 })
}
const PrintError = (message: string) => {
    toastEventBus.emit('add', { severity: 'error', summary: t('general.error'), detail: message, life: 3000 })
}
const PrintWarning = (message: string) => {
    toastEventBus.emit('add', { severity: 'warn', summary: t('general.warning'), detail: message, life: 3000 })
}

export { PrintSuccess, PrintError, PrintWarning }
